<template>
    <button @click="open" class="items-center text-xs lg:text-sm btn btn-sm text-blue-600 hover:text-blue-400 mb-2 mt-0 sm:mt-2">
        <span class="mr-1">FlipCharts</span>
        <i class="fas fa-chart-area"></i>
    </button>
</template>

<script setup>
import { inject } from 'vue';

const props = defineProps({
    defaultRows: {
        type: Array,
        default: () => undefined
    },
});

const eventBus = inject('eventBus');

function open() {
    if (props.defaultRows) {
        let symbols = props.defaultRows.map(row => row.symbol).filter((symbol) => symbol !== undefined);
        eventBus.emit('flipcharts', symbols);
    } else {
        eventBus.emit('flipcharts');
    }
}
</script>
